import React from 'react';
import { useSelector } from 'react-redux';
import CmpProjectInfo from '../../../components/projectmng/info/CmpProjectInfo';


const ProjectInfoContainer = ({ handleGoBack }) => {
  const { project } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project
  }));

  

  return <CmpProjectInfo project={project}  handleGoBack={handleGoBack} />;
};

export default ProjectInfoContainer;
